(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.view
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.overview.big-figures.view
    :refer [overview-figures-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.basic-information.view
    :refer [basic-information-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.view
    :refer [portfolio-locations-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.return-development.view
    :refer [return-development-card]]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.overview.recent-development-figures.view :as recent-dev]
   [frontend.ui.component.lp-portal.report.module.chart-card :as chart-card]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]
   [frontend.ui.component.lp-portal.report.tearsheet.largest-investments-at-fair-value.view :as
    largest-investments]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.common.view :as re]))

(defn tearsheet-section
  [{:keys [recent-development largest-investment-by-nav portfolio-locations basic-information]
    :as   tearsheet} props]
  [section
   "Tear sheet"
   (str "tearsheet-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [grid/row {}
     [grid/column {:large 6}
      [return-development-card tearsheet props]]
     [grid/column {:large 6}
      #_[largest-investments/largest-investments-by-NAV largest-investment-by-nav props]
      [portfolio-locations-card portfolio-locations props]]]
    [:div
     [basic-information-card tearsheet props]]]])

(defn overview-section
  [{:keys [overview-figures
           recent-development-text
           highlights
           lettable-area-by-sector
           leased-area-by-tenant]} props]
  [section
   "Overview"
   (str "overview-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [overview-figures-card overview-figures props]
    [recent-dev/recent-development-with-highlights-card recent-development-text highlights
     (assoc props :title "Fund Figures")]
    [grid/row {}
     [grid/column {:span 6}
      [chart-card/view "Lettable area by sector, sqm" lettable-area-by-sector props]]
     [grid/column {:span 6}
      [chart-card/view "Leased area by tenant, sqm" leased-area-by-tenant props]]]]])

(defn financial-performance-section
  [{:keys [noi financial-performance-text]} props]
  [section
   "Financial Performance"
   (str "financial-performance-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [free-text-card/view "Financial Performance"
     financial-performance-text props]
    [chart-card/view "NOI 1" noi props]]])

(defn debt-financing-section
  [{:keys [debt-key-figures debt-financing-text]} props]
  [section
   "Debt financing"
   (str "debt-financing-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [grid/row {}
     [grid/column {:large 6}
      [free-text-card/view "Description" debt-financing-text props]]
     [grid/column {:large 6}
      [tabular-card/dynamic-table "Portfolio Debt key figures" debt-key-figures props]]]]])

(defn details-and-figures-section
  [{:keys [current-portfolio
           limited-partners
           investment-summary
           senior-loan-facility
           nav-breakdown]} props]
  [section
   "Details and figures"
   (str "details-and-figures-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [tabular-card/dynamic-table "Current Portfolio, €" current-portfolio props]
    [tabular-card/dynamic-table "Investment summary, €" investment-summary props]
    [tabular-card/dynamic-table "Investors, €" limited-partners props]
    #_[tabular-card/dynamic-table "Senior Loan Facility" senior-loan-facility props]
    [tabular-card/dynamic-table "NAV breakdown, €" nav-breakdown props]]])

(defn financial-statements-section
  [{:keys [consolidated-income-statement statement-of-financial-position]} props]
  [section
   "Financial statements"
   (str "financial-statements-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [tabular-card/dynamic-table "Consolidated Income Statement (FAS), €"
     consolidated-income-statement
     props]
    [tabular-card/dynamic-table "Consolidated Balance Sheet (FAS), €"
     statement-of-financial-position
     props]]])

(defn risk-assessment-section
  [risk-assessment-text props]
  [section
   "Risk Assessment"
   (str "risk-assessment-"
        (some->> props
                 :report
                 :db/id))
   [free-text-card/row-view "" risk-assessment-text props]])

(defn koke
  [{:keys [fund-ui-data] :as props}]

  (let [{:keys [tearsheet
                overview
                financial-performance
                esg
                debt-financing
                details-and-figures
                risk-assessment-text
                financial-statements]}
        fund-ui-data]
    [:div
     ^{:key :tearsheet}
     [tearsheet-section tearsheet props]
     ^{:key :overview}
     [overview-section overview props]
     ^{:key :financial-performance}
     [financial-performance-section financial-performance props]
     ^{:key :debt-financing}
     [debt-financing-section debt-financing props]
     ^{:key :esg}
     [:div
      [re/esg-section esg props]]
     ^{:key :details-and-figures}
     [details-and-figures-section details-and-figures props]
     ^{:key :financial-statements}
     [financial-statements-section financial-statements props]
     ^{:key :risk-assessment}
     [risk-assessment-section risk-assessment-text props]
    ]))
